import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

export const UNSAVED_CHANGES_MODAL_TEST_ID = 'unsaved-changes-modal';
export const UNSAVED_CHANGES_MODAL_SAVE_BUTTON_TEST_ID = 'unsaved-changes-modal-save-button';
export const UNSAVED_CHANGES_MODAL_DISCARD_BUTTON_TEST_ID = 'unsaved-changes-modal-discard-button';

type Props = {
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
  isLoading: boolean;
  isValid: boolean;
};

/**
 * TODO: Update to use `ModalContext` and infra
 * The props being passed in can be made available via `UnsavedChangesContext`
 */
export const UnsavedChangesModal = ({
  onClose,
  onDiscard,
  onSave,
  isValid,
  isLoading = false,
}: Props) => {
  return (
    <Modal
      withPortal
      onClose={onClose}
      isModalOpen={true}
      id={UNSAVED_CHANGES_MODAL_TEST_ID}
      data-test={UNSAVED_CHANGES_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>Unsaved changes</ModalHeader>
      <ModalBody>This campaign has been edited. Do you want to save your changes?</ModalBody>
      <ModalFooter>
        <Button
          data-test={UNSAVED_CHANGES_MODAL_DISCARD_BUTTON_TEST_ID}
          onClick={onDiscard}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          Discard changes
        </Button>
        <Button
          isDisabled={!isValid}
          isLoading={isLoading}
          data-test={UNSAVED_CHANGES_MODAL_SAVE_BUTTON_TEST_ID}
          onClick={onSave}
          size={BUTTON_SIZES.LARGE}
        >
          Save changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
